var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('waste-partner-form',{attrs:{"propItem":_vm.item,"rvms":_vm.rvms,"brands":_vm.brands,"manufacturers":_vm.manufacturers,"materials":_vm.materials}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }